import React from "react";



import { useParams } from "react-router-dom";
import { useGetSingleSourceQuery, useUpdateSourceMutation } from "../../../../features/master/source/sourceApiSlice";
import EditService from "../EditServices";



export default function Index() {
  const { id } = useParams();
  const { data, refetch } = useGetSingleSourceQuery(id);
  const [updateSource , {isLoading}] = useUpdateSourceMutation();


  return (
      <EditService isLoading={isLoading}
          data={data?.source}
          refetch={refetch}
          id={id}
          name={"source"}
          title={"Source"}
          updatedData={updateSource}
      />
  );
}
